import axiosInstance from "./axiosInstance";

export const getCdmpSection = (slug) => {
  return axiosInstance.get(
    `/api/cdmp-sections?filters[slug][$eq]=${slug}`
  );
};

export const getCdmpDocuments = (slug) => {
  return axiosInstance.get(
    `/api/cdmp-documents?filters[section][slug][$eq]=${slug}&populate=*`
  );
};
